var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-container"},[_c('FontAwesomeIcon',{staticClass:"load",attrs:{"icon":['fas', 'spinner'],"spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }